module.exports = __webpack_public_path__ + "img/sohba.a89e343.webp";